function initializeBundleForm() {
  document.querySelectorAll('[data-eversa-bundles]').forEach(panel => {
    if (panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    const productForm = panel.querySelector('#EversaBundleProduct');
    let target = 1;
    let syncing = false;
    const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
    async function syncQuantity() {
      if (syncing) return;
      syncing = true;
      panel.classList.add('bundle-syncing');
      try {
        for (let step = 0; step < 8; step++) {
          const input = panel.querySelector('.rsi-quantity-input');
          if (!input) break;
          const current = Number(input.value);
          if (current === target) break;
          const control = panel.querySelector(current < target ? '.rsi-quantity-increase' : '.rsi-quantity-decrease');
          if (!control || control.disabled) break;
          control.click();
          for (let wait = 0; wait < 40; wait++) {
            await pause(100);
            const updated = panel.querySelector('.rsi-quantity-input');
            if (updated && Number(updated.value) !== current) break;
          }
        }
        const actual = Number(panel.querySelector('.rsi-quantity-input')?.value);
        if (Number.isInteger(actual) && actual >= 1 && actual <= 3) {
          productForm.querySelector(`[name="bundle_quantity"][value="${actual}"]`).checked = true;
          productForm.querySelector('[data-bundle-quantity]').value = String(actual);
        }
      } finally {
        syncing = false;
        panel.classList.remove('bundle-syncing');
      }
    }
    productForm.addEventListener('submit', event => event.preventDefault());
    productForm.addEventListener('change', event => {
      if (event.target.name !== 'bundle_quantity') return;
      target = Number(event.target.value);
      syncQuantity();
    });
  });
}
initializeBundleForm();
document.addEventListener('shopify:section:load', initializeBundleForm);
